import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {BriefTillSummaryReportData} from "./brief-till-summary-report.data";

@Injectable()
export class BriefTillSummaryReportModel extends ReportModel<BriefTillSummaryReportData> {
    constructor(injector: Injector) {
        super(injector, BriefTillSummaryReportData)
    }
}
